import I18n from 'i18n-js';
import React, { Component } from 'react';
import { string, oneOf, oneOfType, bool } from 'prop-types';
import classnames from 'classnames';

class Input extends Component {
  static propTypes = {
    id: string.isRequired,
    error: oneOfType([bool, string]),
    label: string.isRequired,
    labelInside: bool,
    legend: string,
    placeholder: string,
    type: oneOf(['text', 'password', 'email']),
    optional: bool,
    className: string,
  };

  static defaultProps = {
    error: null,
    labelInside: false,
    legend: null,
    placeholder: '',
    type: 'text',
    optional: false,
    className: null,
  };

  static emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  state = {
    legendContent: this.props.legend,
    errorContent: this.props.error,
  };

  constructor(props) {
    super(props);

    this.displayErrors = this.displayErrors.bind(this);
  }

  /**
   * {@inheritdoc}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.legend === state.legendContent || props.error === state.errorContent) {
      return null;
    }

    return {
      legendContent: props.legend,
      errorContent: props.error,
    };
  }

  /**
   * @return {String}
   */
  get value() {
    const { errorContent } = this.state;

    if (errorContent && errorContent.length) {
      return null;
    }

    return this.input.value;
  }

  /**
   * @param {String} value
   */
  set value(value) {
    this.input.value = value;
  }

  displayErrors() {
    const { value } = this.input;
    const { type } = this.props;

    // Empty
    if (!value.length) {
      this.setState({ errorContent: I18n.t('common.form.input:empty') });

      return;
    }

    // Email
    if ((type === 'email' || value.includes('@')) && !Input.emailRegex.test(value)) {
      this.setState({ errorContent: I18n.t('common.form.email:invalid') });

      return;
    }

    this.setState({ errorContent: null });
  }

  /**
   * {@inheritdoc}
   */
  render() {
    const { legendContent, errorContent } = this.state;
    const {
      id,
      error, // eslint-disable-line no-unused-vars
      label,
      labelInside,
      legend, // eslint-disable-line no-unused-vars
      placeholder,
      type,
      optional,
      className,
      ...props
    } = this.props;

    const labelClasses = classnames('form-group__label', {
      'form-group__label--inside': labelInside,
    });

    return (
      <div className="form-group">
        <label htmlFor={id} className={labelClasses}>{label}{optional || '*'}</label>
        {typeof errorContent === 'string' && (
          <span className="form-group__error">{errorContent}</span>
        )}
        <input
          id={id}
          className={classnames('form-group__input', className)}
          type={type}
          placeholder={placeholder}
          ref={(input) => { this.input = input; }}
          onBlur={this.displayErrors}
          {...props}
        />
        {legendContent && (
          <small className="form-group__legend">{legendContent}</small>
        )}
      </div>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/modules/common/components/Input.js